'use strict';

import './modules/polyfill-foreach.js';
import './modules/keyboard-mouse.js';
import './modules/search-toggle.js';

// window.onscroll = () => {
// 	const scrollTop = window.pageYOffset;

// 	if (scrollTop > 100) {
// 		navbar.classList.add('isScrolling');
// 	} else {
// 		navbar.classList.remove('isScrolling');
// 	}
// };

// if (body.classList.contains('admin-bar')) {
// 	navbar.style.marginTop = '32px';
// }

let observer = new IntersectionObserver((entries, observer) => {
	entries.forEach((entry) => {
		if (entry.intersectionRatio > 0) {
			entry.target.classList.add('animate__animated', entry.isIntersecting);
			entry.target.classList.add('animate__fadeInUp', entry.isIntersecting);
			// entry.target.classList.add('animate__fast', entry.isIntersecting);
		}
	});
});

document.querySelectorAll('.wp-block-columns').forEach((el) => {
	observer.observe(el);
});

document.querySelectorAll('.wp-block-cover__inner-container').forEach((el) => {
	observer.observe(el);
});

document.querySelectorAll('.wp-block-media-text').forEach((el) => {
	observer.observe(el);
});

document.querySelectorAll('.container-employee').forEach((el) => {
	observer.observe(el);
});

const mobileButton = document.querySelector('.mobile__menu-button');
const mobileNavbar = document.getElementById('mobile__navbar');
const mobileClose = document.querySelector('.mobile__menu-close');
const body = document.querySelector('body');

mobileButton.addEventListener('click', function () {
	mobileNavbar.classList.toggle('navbar--is--visible');
	body.classList.toggle('stopScrolling');
});

mobileClose.addEventListener('click', function () {
	mobileNavbar.classList.toggle('navbar--is--visible');
	body.classList.toggle('stopScrolling');
});
